import { Skeleton } from "@mui/material";
import mapboxgl from "mapbox-gl";
import { useMemo, useState } from "react";
import { makeStyles } from "tss-react/mui";
import bbox from "@turf/bbox"

const useStyles = makeStyles()(
  () => ({
    root: {
      position: "relative",
      overflow: "hidden"
    },
    image: {
      width: "100%",
      height: "100%",
      overflow: "hidden",
      opacity: 0,
      transition: "opacity 0.25s"
    },
    skeleton: {
      position: "absolute",
      width: "100%",
      height: "100%",
      zIndex: 99,
      top: 0,
      left: 0,
      transition: "opacity 0.25s"
    },
    skeletonLoaded: {
      opacity: 0,
    },
    imageLoaded: {
      opacity: 1
    }
  })
);

export default function MapboxImage(props) {
  const { geojson, className, zoomLevel, width, height } = props;
  const { classes } = useStyles();

  const [loaded, setLoaded] = useState(false);

  const geojsonData = useMemo(() => {
    if (typeof geojson === "string") {
      return encodeURIComponent(geojson);
    } else {
      return encodeURIComponent(JSON.stringify(geojson));
    }
  }, [geojson]);


  const center = useMemo(() => {
    if (typeof zoomLevel === "number") {
      const bounds = bbox(geojson);
      const centerLng = (bounds[0] + bounds[2]) / 2;
      const centerLat = (bounds[1] + bounds[3]) / 2;
      return `${centerLng},${centerLat},${zoomLevel}`;
    } else {
      return "auto";
    }
  }, [geojson, zoomLevel]);


  return (
    <div className={`${classes.root} ${className || ""}`}>
      <img
        className={`${classes.image} ${loaded ? classes.imageLoaded : ""}`}
        onLoad={() => setLoaded(true)}
        src={`https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/geojson(${geojsonData})/${center}/${width || "500"}x${height || "500"}?access_token=${mapboxgl.accessToken}`}
      />
      {!loaded ? <Skeleton alt="map section" className={`${classes.skeleton} ${loaded ? classes.skeletonLoaded : ""}`} variant="rectangular" /> : null}
    </div>
  );
}

